import SectionTitle from "../../../../common/sectionTitle";
import FeaturesCard from "./featuresCard/FeaturesCard";
import FeaturesStyleWrapper from "./Features.style";
import data from "../../../../assets/data/featuresDataV1"

const Features = () => {
  return (
    <FeaturesStyleWrapper className="v2_about_us_section" id="features">
      <div className="container">
        <div className="features_title">
          <SectionTitle
            title="The Heart Of The Blockchain Of Value Chain"
            subtitle="CRYPTOBIT FEATURES"
          />
        </div>


        {/* about card */}
        <div className="row features_items_row">
          {data.map((item, i) => (
            <div key={i} className="features_items col-lg-3 col-md-6 col-sm-6">
              <FeaturesCard {...item} />
            </div>
          ))}
        </div>
      </div>
    </FeaturesStyleWrapper>
  );
};

export default Features;
